export enum TableState {
    ALUNO,
    AULA
}